/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteCustomerMutationVariables = Types.Exact<{
  input: Types.CustomerDeleteInput;
}>;


export type DeleteCustomerMutation = { __typename: 'Mutation', customerDelete: { __typename: 'CustomerDeletePayload', customerId: string } };

export type CustomerDeletePreCheckQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID'];
}>;


export type CustomerDeletePreCheckQuery = { __typename: 'Query', customerDeletePreCheck: { __typename: 'CustomerDeletePreCheckResult', blockingReasons: Array<string>, deletableItems: Array<string> } };

export type DeleteCustomer_CustomerFragment = { __typename: 'Customer', id: string, name: string };

export const DeleteCustomer_CustomerFragmentDoc = gql`
    fragment DeleteCustomer_customer on Customer {
  id
  name
}
    `;
export const DeleteCustomerDocument = gql`
    mutation DeleteCustomer($input: CustomerDeleteInput!) {
  customerDelete(input: $input) {
    customerId
  }
}
    `;
export type DeleteCustomerMutationFn = ApolloReactCommon.MutationFunction<DeleteCustomerMutation, DeleteCustomerMutationVariables>;

/**
 * __useDeleteCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerMutation, { data, loading, error }] = useDeleteCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCustomerMutation, DeleteCustomerMutationVariables>(DeleteCustomerDocument, options);
      }
export type DeleteCustomerMutationHookResult = ReturnType<typeof useDeleteCustomerMutation>;
export type DeleteCustomerMutationResult = ApolloReactCommon.MutationResult<DeleteCustomerMutation>;
export type DeleteCustomerMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const CustomerDeletePreCheckDocument = gql`
    query CustomerDeletePreCheck($customerId: ID!) {
  customerDeletePreCheck(customerId: $customerId) {
    blockingReasons
    deletableItems
  }
}
    `;

/**
 * __useCustomerDeletePreCheckQuery__
 *
 * To run a query within a React component, call `useCustomerDeletePreCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerDeletePreCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerDeletePreCheckQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCustomerDeletePreCheckQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CustomerDeletePreCheckQuery, CustomerDeletePreCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomerDeletePreCheckQuery, CustomerDeletePreCheckQueryVariables>(CustomerDeletePreCheckDocument, options);
      }
export function useCustomerDeletePreCheckLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomerDeletePreCheckQuery, CustomerDeletePreCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomerDeletePreCheckQuery, CustomerDeletePreCheckQueryVariables>(CustomerDeletePreCheckDocument, options);
        }
export type CustomerDeletePreCheckQueryHookResult = ReturnType<typeof useCustomerDeletePreCheckQuery>;
export type CustomerDeletePreCheckLazyQueryHookResult = ReturnType<typeof useCustomerDeletePreCheckLazyQuery>;
export type CustomerDeletePreCheckQueryResult = ApolloReactCommon.QueryResult<CustomerDeletePreCheckQuery, CustomerDeletePreCheckQueryVariables>;